import React from "react"
import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import store from "./store"

import "bootstrap/dist/css/bootstrap.css"
import "bootstrap/dist/js/bootstrap.js"
import "./index.scss"
import logger from "./Logger"
import { initReplaneClient } from "./utils/replaneClient"
import { resolveAuthProvider } from "./context/auth/runtime-config"
import initTelemetry from "./telemetry/init"
import ErrorBoundary from "./components/common/ErrorBoundary/ErrorBoundary"

// Builder Styles
// TODO: Revisit
import "./builder/styles/global.scss"

const pageLogger = logger.child({ module: "index" })

const root = ReactDOM.createRoot(document.getElementById("root"))

function keyDownHandler(e) {
  if ((e.ctrlKey || e.metaKey) && e.keyCode === 80) {
    e.preventDefault()
    e.stopImmediatePropagation()
    pageLogger.info("Ctrl+P shortcut detected")
  }
}

document.addEventListener("keydown", keyDownHandler)

const _baseName = process.env.PUBLIC_URL ?? "/"

// Connect to Replane for runtime config (fire-and-forget — app renders with
// hardcoded defaults immediately; components re-render once SDK is ready).
// .catch() prevents an unhandled promise rejection if the SDK's background
// SSE tasks throw after our internal try-catch (e.g. connection timeout).
initReplaneClient().catch(() => {})

// Initialize OpenTelemetry browser tracing (no-op when REACT_APP_OTEL_ENABLED != 'true')
initTelemetry()

// Which IdP to sign in with is decided by the server (Replane `auth.provider`), so it can
// be switched with no redeploy. Ask BEFORE the first render: the sign-in SDK is mounted
// once. resolveAuthProvider is time-boxed and never throws — on failure the build default
// (REACT_APP_AUTH_PROVIDER) is used.
resolveAuthProvider().finally(() => {
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <Provider store={store}>
          <App />
        </Provider>
      </ErrorBoundary>
    </React.StrictMode>
  )
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
